/* eslint-disable */
/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import { Button, Tooltip } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import Chip from '@mui/material/Chip';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import moment from 'moment';
import { useHistory } from 'react-router';
import { ArrowRight, EditIcon, Eye, Filter, RefreshCcw, Upload, View, CheckCircle2, Trash2, Clock, Archive, CircleX, Ban, RotateCcw } from 'lucide-react';
import { analyticsAction, formActions, modalActions } from '../../../Actions';
import { ListTable } from '../../../Components/ListTable';
import { POItemsModal } from '../../../Components/Modals/POItemsModal';
import styles from './VendorOrdersListPage.module.scss';
import { VanImageModal } from '../../../Components/Modals/VanImageModal';
import assetServices from '../../../Services/AssetServices/asset.services';
import { notificationServices } from '../../../Services';
import inventoryAnalyticsServices from '../../../Services/Analytics Services/inventory-analytics.services';
import { AlertModal } from '../../../Components/Modals';
import { VendorOrderGrnsModal } from '../../../Components/Modals/VendorOrderGrns';
import { FileUploaderModal } from '../../../Components/Modals/FileUploaderModal';
import ImagesFinder from '../../../Components/ImagesFinder/ImagesFinder';
import {
	addCommas,
	classes, filtersInfoChip, getActionColumn, handleImagePreview, handleOrderStatus, handleResponseStreamDownload,
} from '../../../Helpers';
import { purchaseRequestServices } from '@/Services/PurchaseRequestServices/PurchaseRequestService';
import { urls } from '../../../Constants';
import ExportFiltersDrawer from '@/Components/Drawers/ExportFiltersDrawer/ExportFiltersDrawer';
import drawerActions from '@/Actions/drawer.actions';
import orderAnalyticsServices from '@/Services/Analytics Services/orderAnalytics.services';
import DebitCreditListDrawer from '@/Components/Drawers/DebitCreditListDrawer/DebitCreditListDrawer';
import { Button as SButton } from '@/Components/ui/button';
import AssetTransitModal from '@/Components/Modals/AssetTransitModal/AssetTransitModal';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import DatePickerModal from '../Inventory Analytics/PurchaseOrderList/DatePickerModal';
import { BackdropLoader } from '@/Components/Loaders';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import GlobalSearch from '@/Components/globalSearch/search';
import OrderImagesModal from '@/Components/Modals/OrderImagesModal/OrderImagesModal';
import { getStorageKey } from '../CreatePurchaseOrder/CreatePurchaseOrder.config';
import { loadState } from '@/Helpers/persistenceUtils';
import { DocumentModal } from '../Inventory Analytics/PurchaseOrderList/docModal';
import utilsServices from '@/Services/utilsServies.services';
import MultiPoModal from '@/Components/Modals/MultiPoModal/multiPoModal';
import processFlowServices from '@/Services/Analytics Services/process-flow.services';
import { canTakeSalesOrderDoc, SO_DOC_DENIED_MESSAGE } from './salesOrderDocAccess';

const TABLE_COLUMNS = [
	{
		title: 'PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client PO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client SO Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Ref No',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Dispatch By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Buyer',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Deliver To',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Status',
		config: {
			type: 'DATA',
		},
	},
	// {
	// 	title: 'Vendor Challan ID',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	// {
	// 	title: 'Buyer Challan ID',
	// 	config: {
	// 		type: 'DATA',
	// 	},
	// },
	{
		title: 'CREATED BY',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Last Action BY',
		config: {
			type: 'DATA',
		},
	},
];

const SPECIAL_COLUMNS = [
	{
		title: 'order Completion',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Lead Time (Days)',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Generation Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Van Temp',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vehicle No',
		config: {
			type: 'DATA'
		}
	},
	{
		title: 'Vehicle Image at Dispatch',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vehicle Image at Receiving',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Temp Meter Image',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Expected Receive date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Order Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Receiving Process',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMN = [
	{
		title: 'Download',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'View More',
		config: {
			type: 'VIEW',
		},
	},
	{
		title: 'Actions',
		config: {
			type: 'CANCEL',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'MORE',
		config: {
			type: 'MORE',
		},
	},
];
const COLMAP = {
	'PO Id': 'id',
	'Client PO Id': 'clientPoId',
	'SO Id': 'id',
	'Client SO Id': 'clientPoId',
	'Order Ref No': 'externalOrderRef',
	'Order Date': 'createdAt',
	'Dispatch By': 'scheduledAt',
	'Delivery Time': 'deliveryTime',
	'Deliver From': 'fromStoreName',
	'Deliver To': 'storeName',
	BASE: 'fromStoreName',
	'Expected Receive date': 'id',
	'Van Temp': 'receivingTemp',
	'Temp Meter Image': 'receivingTempImage',
	'Order Status': 'id',
	'Vendor Challan ID': 'vendorChallanId',
	Vendor: 'vendorName',
	Buyer: 'vendorName',
	'Buyer Challan ID': 'buyerChallanId',
	'CREATED BY': 'initiatedByName',
	'Last Action BY': 'l1ActionByName',
	'Generation Type': 'id',
	'Vehicle No': 'orderImages',
	'Vehicle Image at Dispatch': 'orderImages',
	'Vehicle Image at Receiving': 'orderImages',
	'Receiving Process': 'id',
};

const filterOrderStatus = [
	'CANCELLED',
	'PENDING',
	'FULFILLED',
	'APPROVAL_PENDING',
	'APPROVAL_REJECTED',
	'ABANDONED',
	'DISPATCH',
	'TRANSIT',
	'UNLOADING',
	'VERIFICATION',
];
const vendorOrderStatus = [
	'CANCELLED',
	'PENDING',
	'FULFILLED',
	'APPROVAL_PENDING',
	'APPROVAL_REJECTED',
	'ABANDONED',
];


const dateTypeArr = [
	{
		label: 'Order Date',
		value: 'ordered',
	},
	{
		label: 'Scheduled For',
		value: 'scheduled',
	},
	{
		label: 'Expected Dispatch Date',
		value: 'dispatchDate',
	},
	{
		label: 'GRN Date',
		value: 'grn',
	},
	{
		label: 'Invoice Date',
		value: 'invoiced',
	},
	{
		label: 'Receive Date',
		value: 'received',
	},
];

const vendorOrdersExportTypes = [
	{
		label: 'Invoice-Wise Purchase Register',
		value: 'invoiceWise',
	},
	{
		label: 'Item-Wise Purchase Register',
		value: 'grnItemWise',
	},
	{
		label: 'Item-Wise PO Fulfillment',
		value: 'poItemWise',
	},
];
const internalOrdersExportTypes = [
	{
		label: 'Invoice-Item wise Sales Register',
		value: 'invoiceItemWiseSales',
	},
	{
		label: 'Item-Wise GRN Fullfilment',
		value: 'itemWiseGrn',
	},
	{
		label: 'Item-Wise Sales Register',
		value: 'itemWiseSales',
	},
];

function VendorOrdersListPage(props) {
	const {
		data,
		type,
		toggleModal,
		// toggleFileUploaderModal,
		toggleAlert,
		fetchOrdersList,
		toggleVendorOrderGrnsModal,
		dateRangeFilter,
		navState,
		userPermissions,
		toggleVanImageModal,
		vendors,
		fetchVendors,
		resetInventoryAnalyticsState,
		toggleExportFiltersDrawer,
		categoriesList,
		subCategoriesList,
		fetchSubCategories,
		toggleDebitCreditListDrawer,
		toggleAssetTransit,
		userList,
		fetchUserList,
		toggleFiltersDrawer,
		toggleOrderImagesModal
	} = props;
	const isInternalOrders = type === 'internalPoList';
	const isBuyer = type === 'BUYER';
	const isManualProduction = type === 'manualProduction';
	const isVendorOrders = !isBuyer && !isManualProduction && !isInternalOrders;
	const history = useHistory();
	const location = useLocation();
	const [grnStatus, setGrnStatus] = useState('ALL');
	const [loading, setLoading] = useState(false);
	const [update, setUpdate] = useState(-1);
	const exportFilters = useRef({});
	const [search, setSearch] = useState({});
	const [filterValue, setFilterValue] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	const [datePickerModalState, setDatePickerModalState] = useState({
		show: false,
		heading: '',
		currentPo: null,
	});
	const [filters, setFilters] = useState({
		storeId: null,
		dateRange: {
			startDate: new Date(),
			endDate: new Date(),
		},
	});
	const levels = [3, 4];
	// Receiving Process column: orders already carry `toProcessName` most of the
	// time, but some rows only have `toProcessId`. For those, resolve the name
	// from that row's store process list and cache it (keyed by store+process,
	// since process node ids are only unique within a store's process flow).
	const [processNameMap, setProcessNameMap] = useState({});

	const { userConfig = {}, appConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	// L3 is approve-only on Vendor Orders alone; other order types
	// (Buyer, Manual Production, Internal) keep create/edit for L3.
	const isL3Blocked = level === 3 && isVendorOrders;
	const { userRolesDict } = userConfig || {};
	const { configs = {} } = appConfig || {};
	const { console3Action = false } = configs || {};
	const isBakingoCustomer = appConfig?.customerId === 52;
	// Single rule for "may this PO's generated document leave the screen". Both the
	// Download column chip and the PDF viewer inside POItemsModal read it, so the doc
	// can never be blocked in one place and downloadable in the other. Customer 52 is
	// exempted deliberately (pre-existing behaviour).
	// Buyer Sales Orders: only SO_DOC_ROLES may download / print the Sales Order.
	const canTakeSoDoc = canTakeSalesOrderDoc(userRolesDict);
	const isPoDocDownloadable = useCallback(
		(orderStatus) => {
			if (isBuyer && !canTakeSoDoc) return false;
			return isBakingoCustomer
				|| !['APPROVAL_PENDING', 'APPROVAL_REJECTED', 'CANCELLED'].includes(orderStatus);
		},
		[isBakingoCustomer, isBuyer, canTakeSoDoc]
	);
	const isNagaOrDevBuyer =
		(appConfig?.customerId === 72 || appConfig?.customerId === 5) &&
		!isInternalOrders &&
		!isBuyer;
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const procurmentRole = Object?.values?.(userRolesDict ?? {}).includes('Procurement');
	const dispatch = useDispatch();


	const navRequisites =
		navState?.[
			isInternalOrders
				? urls.INTERNAL_PURCHASE_ORDERS
				: urls.PURCHASE_ORDERS
		]?.requisites ?? [];
	const navSelectedStore = navRequisites?.find((ele) => {
		return ele?.type === 'store';
	});

	useEffect(() => {
		exportFilters.current = {
			...exportFilters.current,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,
		};
	}, [navSelectedStore?.value?.id]);

	// Discard purchase-order drafts older than 30 minutes on load, so a stale
	// draft never resurfaces in the "Draft Exists" prompt or the Edit Draft button.
	useEffect(() => {
		const DRAFT_TTL_MS = 30 * 60 * 1000;
		// All PO draft types: vendor(1), internal(2,3), buyer(8).
		[1, 2, 3, 8].forEach((draftTypeId) => {
			const key = getStorageKey(draftTypeId);
			const draft = loadState(key);
			if (
				draft &&
				(!draft.draftSavedAt ||
					Date.now() - draft.draftSavedAt >= DRAFT_TTL_MS)
			) {
				localStorage.removeItem(key);
			}
		});
	}, []);

	useEffect(() => {
		fetchVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		return () => {
			resetInventoryAnalyticsState({
				entity: 'INVENTORY_ANALYTICS',
				method: 'VENDOR_ORDERS_LIST',
				data: [],
			});
		};
	}, [type]);

	useEffect(() => {
		const itemsMissingProcessName = data?.filter((item) => {
			return (
				item?.toProcessId &&
				!item?.toProcessName &&
				!processNameMap[`${item?.storeId}_${item?.toProcessId}`]
			);
		});
		if (!itemsMissingProcessName?.length) return;
		const storeIds = [
			...new Set(
				itemsMissingProcessName
					.map((item) => item?.storeId)
					.filter(Boolean)
			),
		];
		(async () => {
			const newEntries = {};
			await Promise.all(
				storeIds.map(async (storeId) => {
					try {
						const response = await processFlowServices.fetchNodes({
							params: { storeId },
						});
						if (response?.statusCode === 200) {
							response?.data?.nodes?.forEach((node) => {
								if (node?.id != null) {
									newEntries[`${storeId}_${node.id}`] =
										node?.data?.heading ?? node?.name ?? '-';
								}
							});
						}
					} catch (error) {
						// eslint-disable-next-line no-console
						console.log(error);
					}
				})
			);
			if (Object.keys(newEntries).length) {
				setProcessNameMap((prev) => {
					return { ...prev, ...newEntries };
				});
			}
		})();
	}, [data]);


	const handleCancelPo = (id, clientPoId, isClose = false) => {
		// eslint-disable-next-line no-console
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Cancelling Order ${clientPoId || id || ''}`.trim(),
			});
			try {
				const resp = await inventoryAnalyticsServices.changeOrderStatus(
					{
						params: {
							poId: id,
							status: isClose ? 'CLOSE' : 'CANCEL',
							...(isClose && { forceCancelShipment: true }),
						},
					}
				);
				notificationServices.generateNotification({
					type: 'success',
					message: resp?.status,
					config: {
						id: notificationId,
					},
				});
				setUpdate((prev) => {
					return prev + 1;
				});
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	const handleRepushOrder = (id, clientPoId) => {
		(async () => {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Re pushing Order ${clientPoId || ''} to SAP`,
			});
			try {
				const resp = await orderAnalyticsServices.rePushToSap({
					data: {
						poId: id,
					},
				});
				if (resp?.statusCode == 200 && resp?.results?.[0]?.result?.isSuccess) {
					notificationServices.generateNotification({
						type: 'success',
						message: resp?.message ?? resp?.results?.[0]?.result?.Message ?? 'Order repushed to SAP',
						config: {
							id: notificationId,
						},
					});
					fetchVendorsOrders(filterValue, false)
				} else {
					notificationServices.generateNotification({
						type: 'error',
						message: resp?.message ?? resp?.results?.[0]?.result?.Message ?? resp?.status ?? 'Order not repushed to SAP',
						config: {
							id: notificationId,
						},
					});
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: {
						id: notificationId,
					},
				});
			}
		})();
	};

	// const handleDownloadGRN = (downloadLink) => {
	// window.open(downloadLink);
	// };

	const handleViewClick = (item) => {
		const vendorDetails = vendors?.find((ele) => {
			return ele?.id === item?.vendorId;
		});
		const vendorLocation = vendorDetails?.vendor_locations?.find((loc) => {
			return Number(loc?.id) === Number(item?.vendorLocationId);
		});
		const vendorLocationGstin = vendorLocation?.gstin ?? vendorDetails?.gstin ?? '';
		const buyersObj = {
			'Deliver From Store': item?.fromStoreName,
			'Deliver From Store GSTIN': item?.fromStoreGstin ?? '',
			Buyer: item?.vendorName,
			'Buyer GSTIN': vendorLocationGstin,
			'Buyer Address': `${vendorDetails?.shippingAddressCity ?? ''}${vendorDetails?.shippingAddressState ?? ''
				}, ${vendorDetails?.shippingAddressPinCode ?? ''}`,
		};
		const vendorsObj = {
			'Deliver To Store': item?.storeName,
			'Deliver To Store GSTIN': item?.storeGstin ?? '',
			Vendor: item?.vendorName,
			'Vendor GSTIN': vendorLocationGstin,
			'Vendor Address': `${vendorDetails?.shippingAddressCity ?? ''}${vendorDetails?.shippingAddressState ?? ''
				}, ${vendorDetails?.shippingAddressPinCode ?? ''}`,
		};
		const internalObj = {
			'Deliver From Store': item?.fromStoreName,
			'Deliver To Store': item?.storeName,
			'Deliver To Store GSTIN': item?.storeGstin ?? '',
			'Deliver From Store GSTIN': item?.fromStoreGstin ?? '',
			'from Store Address': `${vendorDetails?.shippingAddressCity ?? ''}${vendorDetails?.shippingAddressState ?? ''
				}, ${vendorDetails?.shippingAddressPinCode ?? ''}`,
		};
		toggleModal(true, {
			heading: `PO Items ${item?.clientPoId ? `of ${item?.clientPoId}` : ''
				}`,
			...item,
			showPdf: item?.poURL,
			// Same rule as the Download column: when the doc may not leave the screen,
			// the modal's PDF viewer drops its toolbar (download / print).
			allowDocDownload: isPoDocDownloadable(item?.orderStatus),
			// Buyer Sales Order without an SO_DOC_ROLES role: show a permission message
			// in place of the PDF (the modal also skips fetching it).
			docBlockedMessage: isBuyer && !canTakeSoDoc ? SO_DOC_DENIED_MESSAGE : undefined,
			showTotal: true,
			showPoDetails: true,
			width: '80%',
			height: '95%',
			transactionData: {
				...(isBuyer && buyersObj),
				...(!isBuyer && !isInternalOrders && vendorsObj),
				...(isInternalOrders && internalObj),
				'Order ID': item?.clientPoId,
				'Payment Term': item?.jsonData?.paymentTerm,
				'Order Date': moment(item?.createdAt).format('YYYY-MM-DD'),
				'Dispatch By': moment(item?.scheduledAt).format('YYYY-MM-DD'),
			},
			// Freight & additional charges columns are vendor-order only; the
			// modal shows them based on this flag (not excludedColumns).
			isVendorOrder: !isInternalOrders && !isBuyer,
			excludedColumns: isInternalOrders
				? [
					// 'Packaged',
					'From Process',
					'PO Id',
					'Quantity',
					'Returned Quantity',
					'Returned',
					'Fulfilled',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
					'Standard PO Qty',
				]
				: isBuyer ? [
					'Packaged',
					'Dispatched',
					'Returned Quantity',
					'Received',
					'From Process',
					'PO Id',
					'Quantity',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Recommended Quantity',
					'Standard PO Qty',
				] : [
					'Packaged',
					'Dispatched',
					'Returned Quantity',
					'Received',
					'From Process',
					'PO Id',
					'Last Purchase Rate 1',
					'Last Purchase Rate 2',
					'Last Purchase Rate 3',
					'Quantity',
				],
		});
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [
			'PO ID',
			'Client PO ID',
			'PO Scheduled Date',
			'PO Order Date',
			'PO Order status',
			'PO Raised by',
			'Vendor',
		];
		const downloadBtn = document.createElement('a');
		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const fetchPOGrns = async (orderId) => {
		const req = {
			data: {
				filters: {
					orderId,
				},
				type: 'GRN',
				transactionItems: true,
				children: true,
			},
		};
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'loading...',
		});
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req,
				});
			// eslint-disable-next-line no-empty
			if (response?.statusCode === 200) {
				toggleVendorOrderGrnsModal(true, {
					heading: `GRNs of PO: #${orderId}`,
					grnList: response?.data,
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
				config: {
					id: notificationId,
				},
			});
		}
	};

	const handleViewImages = async (orderId) => {
		try {
			const responseImages = await orderAnalyticsServices.viewOrderImages({
				data: { orderId: orderId, orderType: 'purchaseOrder' },
			});
			const responseItems = await orderAnalyticsServices.fetchOrderItems({
				data: {
					orderId: orderId,
				},
			});

			if (responseImages?.data?.length > 0) {
				const merged = responseImages?.data.map(image => {
					const matchingProduct = responseItems?.data?.items?.find(product => product.itemId === image.itemId);
					return {
						...image,
						...matchingProduct
					};
				});

				toggleOrderImagesModal(true, {
					orderImages: merged
				})
			} else {
				notificationServices.generateNotification({
					type: 'info',
					message: 'No images found for this order.',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Failed to fetch images.',
			});
		}
	};

	const showPOBills = (orderId, clientPoId) => {
		history.push(
			`${urls.EXTENSION}${urls.BILLS}?poId=${orderId}&clientPoId=${clientPoId}`
		);
	};

	const viewMoreOptionsList = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		...(!isBuyer && {
			'View Images': (item, cb) => {
				handleViewImages(item?.id)
				cb()
			}
		}),
		...(!isBuyer && {
			'View GRNs': (item, cb) => {
				fetchPOGrns(item?.id);
				cb();
			},
		}),
		...(!isBuyer && {
			'View Bills': (item, cb) => {
				showPOBills(item?.id, item?.clientPoId);
				cb();
			},
		}),
		// 'View Credits': (item, cb) => {
		// 	history.push(
		// 		`${urls.EXTENSION}${urls.CREDITS}?poId=${item?.id}&clientPoId=${item?.clientPoId}`
		// 	);
		// 	cb();
		// },
		...(!isBuyer && {
			'View Debit/Credit Note': (item, cb) => {
				cb();
				setTimeout(() => {
					toggleDebitCreditListDrawer(true, {
						poId: item?.id,
						heading: `Debit/Credit Notes of ${item?.clientPoId ?? item?.id
							}`,
					});
				}, 100);
			},
		}),
	};

	const internalViewMoreOptions = {
		'View Items': (item, cb) => {
			handleViewClick(item);
			cb();
		},
		'View Debit/Credit Note': (item, cb) => {
			cb();
			setTimeout(() => {
				toggleDebitCreditListDrawer(true, {
					poId: item?.id,
					heading: `Debit/Credit Notes of ${item?.clientPoId ?? item?.id
						}`,
				});
			}, 100);
		},
		'View Assets': async (item, cb) => {
			try {
				const res = await assetServices?.fetchAssetTransitFlow({
					req: {
						params: {
							id: Number(item?.id),
						},
					},
				});
				if (res?.statusCode === 200) {
					const response = res?.data;
					if (response.length > 0) {
						toggleAssetTransit(true, {
							heading: `PoId : ${item?.id}`,
							data: response,
						});
					} else {
						notificationServices?.generateNotification({
							type: 'warning',
							message: 'No assets are packaged yet in this PO',
						});
					}
				}
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
				});
			}
		},
		'View Images': (item, cb) => {
			handleViewImages(item?.id)
			cb()
		}
	};
	const vendorOrder = (data) => {
		const status = data.map((ele) => {
			if (ele === 'FULFILLED') {
				return {
					id: ele,
					title: 'CLOSED',
				};
			}
			return {
				id: ele,
				title: ele,
			};
		});
		return status;
	};
	const renderDownloadField = (item) => {
		// const sendStoreGstin = item?.fromStoreGstin;
		// const receiveStoreGstin = item?.storeGstin;

		return (
			<div
				style={{
					width: '125px',
				}}
				className={styles?.downloadDiv}
			>
				{item?.poURL && isPoDocDownloadable(item?.orderStatus) && (
					<Chip
						size='small'
						label='Order'
						onClick={() => {
							if (item?.poURL) {
								window.open(item?.poURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				{item?.jsonData?.uploadedDoc?.file && (
					<Chip
						size='small'
						label='Refrence Doc'
						onClick={() => {
							window.open(item?.jsonData?.uploadedDoc?.file);
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)
				}
				{item?.deliveryChallanURL && (
					<Chip
						size='small'
						label='DC'
						onClick={() => {
							if (item?.deliveryChallanURL) {
								window.open(item?.deliveryChallanURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				{item?.invoiceURL && (item?.jsonData?.ewayBill?.url || !isBakingoCustomer) && (
					<Chip
						size='small'
						label='Invoice'
						onClick={() => {
							if (item?.invoiceURL) {
								window.open(item?.invoiceURL);
							}
						}}
						icon={<PictureAsPdfIcon />}
					/>
				)}
				{item?.grnURL && (
					<>
						<Chip
							size='small'
							label='GRN'
							onClick={() => {
								if (item?.grnURL) {
									window.open(item?.grnURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					</>
				)}
				{item?.jsonData?.ewayBill?.url && level !== 1 ? (
					<>
						<div
							style={{
								display: 'flex',
								position: 'relative',
								justifyContent: 'center',
								alignItems: 'center',
							}}
						>
							<Chip
								size='small'
								label='Eway Bill'
								onClick={() => {
									if (item?.jsonData?.ewayBill?.url) {
										const anchor =
											document.createElement('a');
										anchor.href = `https://${item?.jsonData?.ewayBill?.url}`;
										anchor.download = 'EwayBill.pdf';
										anchor.target = 'blank';
										anchor.click();
									}
								}}
								icon={<PictureAsPdfIcon />}
							/>
						</div>
					</>
				) : (
					level !== 1 && item?.orderStatus === 'TRANSIT' && (
						<span
							style={{
								cursor: 'pointer',
								color: '#1976d2',
								textDecoration: 'underline',
								fontSize: '12px',
								display: 'inline-block',
								marginLeft: '8px',
								whiteSpace: 'nowrap',
							}}
							onClick={() => {
								const urlType = 'EWAYBILL';
								const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
								history.push(url);
							}}
						>
							Create E-way Bill
						</span>
					)
				)}
				{item?.jsonData?.eInvoice?.eInvoiceUrl ? (
					<>
						{item?.jsonData?.ewayBill?.url ? (
							<Chip
								size='small'
								label='E-Invoice'
								onClick={() => {
									if (item?.jsonData?.eInvoice?.eInvoiceUrl) {
										const anchor =
											document.createElement('a');
										anchor.href =
											item?.jsonData?.eInvoice?.eInvoiceUrl;
										anchor.download = 'E-Invoice.pdf';
										anchor.target = 'blank';
										anchor.click();
									}
								}}
								icon={<PictureAsPdfIcon />}
							/>
						) : (
							<span
								style={{
									color: '#a00',
									fontSize: '10px',
									textAlign: 'center',
									display: 'inline-block',
									// marginLeft: '8px',
									width: '100%',
								}}
							>
								*Generate E-way Bill to download Invoices
							</span>
						)}
					</>
				) : (
					level !== 1 && !['PENDING', 'DISPATCH', 'CANCELLED', 'ABANDONED'].includes(
						item?.orderStatus
					) && (
						<span
							style={{
								cursor: 'pointer',
								color: '#1976d2',
								textDecoration: 'underline',
								fontSize: '12px',
								display: 'inline-block',
								marginLeft: '8px',
								whiteSpace: 'nowrap',
							}}
							onClick={() => {
								const urlType = 'INVOICE';
								const url = `${urls.EXTENSION}${urls.CREATE_EWAY_BILL}?poId=${item?.id}&type=${urlType}`;
								history.push(url);
							}}
						>
							Create E-Invoice
						</span>
					)
				)}
			</div>
		);
	};
	const handleDatePickerModalSetDate = useCallback(async (date, item) => {
		// An abandoned vendor PO is rescheduled through the status endpoint: the new date is set
		// and the PO goes back to PENDING (the backend rejects past dates).
		if (item?.orderStatus === 'ABANDONED') {
			const notificationId = notificationServices.generateNotification({
				type: 'loading',
				message: `Rescheduling ${item?.clientPoId || item?.id || ''}`.trim(),
			});
			try {
				const response = await inventoryAnalyticsServices.changeOrderStatus({
					params: {
						poId: item?.id,
						status: 'RESCHEDULE',
						scheduled: moment(date).format('YYYY-MM-DD'),
					},
				});
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: { id: notificationId },
				});
				setDatePickerModalState({ show: false, heading: '', currentPo: null });
				setUpdate((prev) => prev + 1);
			} catch (error) {
				notificationServices.generateNotification({
					type: 'error',
					message: error,
					config: { id: notificationId },
				});
			}
			return;
		}
		if (
			moment(item?.scheduledAt, 'YYYY-MM-DD HH:mm:ss').format(
				'YYYY-MM-DD'
			) === moment(date).format('YYYY-MM-DD')
		) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Date is already same',
			});
			return;
		}
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Updating Date',
		});
		try {
			const response = await inventoryAnalyticsServices?.editVendorPO({
				params: {
					poId: item?.id,
				},
				data: {
					scheduled: moment(date).format('MM/DD/YYYY'),
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
					config: {
						id: notificationId,
					},
				});
				setFilters((prev) => {
					return {
						...prev,
						blink: !prev?.blink,
					};
				});
				setTimeout(() => {
					notificationServices.generateNotification({
						type: 'wave',
						message: 'Press find again to get latest updates',
						config: {
							id: notificationId,
						},
					});
				}, 1500);
				setDatePickerModalState({
					show: false,
					heading: '',
					currentPo: null,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: {
					id: notificationId,
				},
			});
		}
	}, []);
	const handleDatePickerModalOpen = useCallback((item) => {
		setDatePickerModalState({
			show: true,
			heading: item?.orderStatus === 'ABANDONED'
				? `Reschedule ${item?.clientPoId} (moves it back to Pending)`
				: `Expected Receive date for ${item?.clientPoId}`,
			currentPo: item,
		});
	}, []);

	const fetchingVendorPastPrice = async (vendorId) => {
		let previousPrice = [];
		try {
			const response = await inventoryAnalyticsServices?.vendorPastPrice({
				params: {
					poId: vendorId,
				},
			});
			if (response?.statusCode === 200) {
				previousPrice = response?.data;
				return previousPrice;
			}
		} catch (error) {
			console.log(error);
		}
	}
	const handleReviewModal = async (item, buyersObj, vendorsObj, isInternalObj) => {
		const previousPrice = await fetchingVendorPastPrice(item?.id);
		item.previousPrice = previousPrice;
		const docUploadMandatory = item?.approvalStatus?.currentPendingDocUploadMandatory ?? false;
		toggleModal(true, {
			heading: `${isBuyer
				? 'Items of B2B Sales Order'
				: 'Items of Purchase Order'
				} #${item?.clientPoId ?? item?.id}`,
			pageType: (!isInternalOrders && !isBuyer) && 'vendors',
			...item,
			isApprove: true,
			docUploadMandatory,
			approvalText: isBuyer
				? 'I have checked all the items of B2B SO'
				: 'I have checked all the items of PO',
			showTotal: true,
			showPdf: true,
			showPoDetails: true,
			transactionData: {
				'Order ID': item?.clientPoId,
				'Deliver To Store': item?.storeName,
				...(isBuyer && buyersObj),
				...(!isBuyer &&
					!isInternalOrders &&
					vendorsObj),
				...(isInternalOrders &&
					isInternalObj),
				'Payment Term':
					item?.jsonData?.paymentTerm,
				'Order Date': moment(
					item?.createdAt
				).format('YYYY-MM-DD'),
				'Dispatch By': moment(
					item?.scheduledAt
				).format('YYYY-MM-DD'),
			},
			width: '90%',
			height: '90%',
			excludedColumns: [
				'Packaged',
				'Dispatched',
				'Returned Quantity',
				'Received',
				'Fulfilled',
				'From Process',
				'PO Id',
				'Returned',
				'Quantity',
			],
		});
	};

	const handleOpenDocumentModal = (item, showInput) => {
		dispatch(modalActions.toggleFileUploaderModal(true, {
			heading: 'Upload Document',
			id: item?.id,
			showInput: showInput,
			inputInfo: {
				label: 'POD ID',
				placeholder: 'Enter POD ID',
				mandatory: true,
			},
		}));
	}

	const handleDeleteDocument = async (id) => {
		const req = {
			data: {
				poId: id,
			}
		}
		try {
			const response = await inventoryAnalyticsServices.deleteDocument(req)
			if (response?.statusCode === 200) {
				notificationServices?.generateNotification({
					type: 'success',
					message: 'Document deleted successfully',
				})
				dispatch(modalActions?.toggleAlert(false));
				dispatch(modalActions?.toggleDocumentModal(false));
				fetchVendorsOrders(filterValue, false);
			}
		} catch (error) {
			notificationServices?.generateNotification({
				type: 'error',
				message: error?.message || error,
			})
		}
	}

	const handleAlertModal = async (id) => {
		dispatch(modalActions?.toggleAlert(true, {
			heading: 'Delete Proof of delivery Document',
			message: `Are you sure you want to delete this document of this SO ID ${id}?`,
			handleConfirm: () => handleDeleteDocument(id),
		}));
	}

	const handleViewDocument = async (item) => {
		try {
			const response = await utilsServices?.getBase64FromFileUrl({
				data: {
					docUrls: [item?.jsonData?.buyerUploadedDoc?.doc_db_url],
				},
			});
			if (response?.statusCode === 200) {
				const document = {
					base64url: response?.data?.[item?.jsonData?.buyerUploadedDoc?.doc_db_url],
					uploadedDate: item?.jsonData?.buyerUploadedDoc?.uploadedAt,
					name: item?.jsonData?.buyerUploadedDoc?.fileName,
					podId: item?.jsonData?.buyerUploadedDoc?.podId,
					id: item?.id,
					delete: true,
				}
				dispatch(modalActions?.toggleDocumentModal(true, {
					obj: document, list: [],
					handleDelete: handleAlertModal,
				}));
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message || error,
			});
		}
	}
	const handleDocUpload = async (file, id, podId) => {
		const req = {
			data: {
				id,
				uploadDoc: file,
				podId: podId,
			}
		}
		try {
			const response = await inventoryAnalyticsServices.uploadDocument(req);
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				dispatch(modalActions.toggleFileUploaderModal(false));
				fetchVendorsOrders(filterValue, false);
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error?.message,
			});
		}
	};

	const SPECIAL_ITEMS = {
		'Client PO Id': (clientPoId, item) => {
			if (!clientPoId) {
				return '-';
			}
			return (
				<div
					role='button'
					tabIndex={0}
					style={{
						cursor: 'pointer',
						color: '#2563eb',
						textDecoration: 'underline',
						textAlign: 'left',
					}}
					onClick={() => handleViewClick(item)}
				>
					{clientPoId}
				</div>
			);
		},
		'Client SO Id': (clientSoId, item) => {
			if (!clientSoId) {
				return '-';
			}
			return (
				<div
					role='button'
					tabIndex={0}
					style={{
						cursor: 'pointer',
						color: '#2563eb',
						textDecoration: 'underline',
						textAlign: 'left',
					}}
					onClick={() => handleViewClick(item)}
				>
					{clientSoId}
				</div>
			);
		},
		'order Completion': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const totalQuantity = item?.items?.reduce((acc, curr) => acc + curr?.qty, 0);
			const fullfiledQuantity = item?.items?.reduce((acc, curr) => acc + curr?.fulfilled, 0);
			const completionPercentage = (fullfiledQuantity / totalQuantity) * 100;
			return completionPercentage ? `${completionPercentage.toFixed(2)}%` : '0%';
		},
		'Order Status': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			if (item?.orderStatus === 'APPROVAL_REJECTED') {
				return (
					<div className={styles.rejected}>
						<p>
							{item?.orderStatus?.split('_')?.join(' ')}
							{item?.jsonData?.rejectionReason
								? ` (Reason: ${item?.jsonData?.rejectionReason})`
								: ''}
						</p>
					</div>
				);
			}
			if (item?.orderStatus === 'PENDING') {
				return (
					<div className={`flex flex-col gap-1 ${item?.jsonData?.approveReason ? 'justify-center border border-gray-200 rounded-md p-2' : ''}`}>
						<span className='text-[14px]'>
							{item?.orderStatus}
						</span>
						<p className='text-[14px]'>
							{item?.jsonData?.approveReason
								? `(Approval Reason: ${item?.jsonData?.approveReason})` : ''}
						</p>
					</div>
				);
			}
			return handleOrderStatus(item?.orderStatus);
		},
		'Van Temp': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return item?.receivingTemp ?? '-';
		},
		'Last Action BY': (lastActionBy, item) => {
			const isAutoApproved = item?.jsonData?.autoApproveResult?.autoApproveStatus;
			return (
				<div className="flex flex-col items-center gap-0.5">
					{isAutoApproved && (
						<div className='text-yellow-600 text-xs'>
							AUTO APPROVED
						</div>
					)}
					<div className="text-md">
						{lastActionBy}
					</div>
				</div>
			);
		},
		'Generation Type': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const generationType = item?.jsonData?.deltaType;
			if (!generationType) return (
				<span className='text-gray-700'>Regular</span>
			);
			if (generationType === 'UNDER_RECEIVING') return (
				<div className='text-red-700 text-[12px]'>Under Reciving</div>
			);
			if (generationType === 'EXCESS_RECEIVING') return (
				<div className='text-red-700 text-[12px]'>Excess Reciving</div>
			);
		},
		'Expected Receive date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const status = [
				'CANCELLED',
				'CLOSED',
				'ABANDONED',
				'UNLOADING',
				'VERIFICATION',
			];
			// An abandoned vendor PO can be given a new date, which reopens it (RESCHEDULE),
			// but only while its scheduled date is at most 15 days old (backend enforces too).
			const isAbandoned = isVendorOrders && item?.orderStatus === 'ABANDONED';
			const scheduledDay = item?.scheduledAt
				? moment(item.scheduledAt.split(' ')[0], 'YYYY-MM-DD')
				: null;
			const tooOldToReopen = isAbandoned && scheduledDay?.isValid()
				&& moment().startOf('day').diff(scheduledDay, 'days') > 15;
			const canReschedule = isAbandoned && !tooOldToReopen;
			if (tooOldToReopen) {
				return (
					<Tooltip title='Cannot reopen: scheduled date is more than 15 days old'>
						<span className='text-gray-700 block w-[7rem]'>
							{item?.scheduledAt?.split(' ')[0] ?? '-'}
						</span>
					</Tooltip>
				);
			}
			// On Vendor Orders, L3 is approve-only — no date editing there.
			if ((levels.includes(level) && !isL3Blocked && (isInternal || procurmentRole)) && (!status.includes(item?.orderStatus) || canReschedule)) {
				return (
					<div
						className='flex w-36 items-center justify-between border border-gray-200 p-2 cursor-pointer hover:bg-gray-50 rounded-md transition-colors'
						onClick={() => {
							handleDatePickerModalOpen(item);
						}}
					>
						<span className='text-gray-700'>
							{item?.scheduledAt?.split(' ')[0] ?? '-'}
						</span>
						<EditIcon className='text-gray-500 hover:text-gray-700' />
					</div>
				);
			} else {
				return (
					<span className='text-gray-700 block w-[7rem]'>
						{item?.scheduledAt?.split(' ')[0] ?? '-'}
					</span>
				);
			}
		},
		'Temp Meter Image': (id, src) => {
			const item = data?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{item?.receivingTempImage ? (
						// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
						<img
							onClick={() => {
								toggleVanImageModal(true, {
									heading: `${item?.id ?? '-'} at ${item?.scheduledAt
										}`,
									image: item?.receivingTempImage,
									vanTemp: item?.receivingTemp,
									id: item?.id,
									// image: 'https://placehold.co/600x400',
									// height: 400,
								});
							}}
							width={100}
							height={50}
							// src='https://placehold.co/600x400'
							src={item?.receivingTempImage}
							alt={src}
						/>
					) : (
						<>-</>
					)}
				</div>
			);
		},
		'Vehicle No': (itemId, data) => {
			return data?.PRE_DISPATCH?.[0]?.vehicleNumber;
		},
		'Vehicle Image at Dispatch': (itemId, data) => {
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl ? (
						<img
							onClick={() => handleImagePreview(data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl)}
							width={100}
							height={50}
							src={data?.PRE_DISPATCH_TEMP?.[0]?.imageUrl}
						/>
					) : (
						<>-</>
					)}
				</div>
			)
		},
		'Vehicle Image at Reciving': (itemId, data) => {
			return (
				<div
					style={{
						width: '5rem',
						display: 'flex',
						cursor: 'pointer',
						alignContent: 'center',
						justifyContent: 'space-evenly',
						justifyItems: 'center',
					}}
				>
					{data?.VERIFICATION_START?.[0]?.imageUrl ? (
						<img
							onClick={() => handleImagePreview(data?.VERIFICATION_START?.[0]?.imageUrl)}
							width={100}
							height={50}
							src={data?.VERIFICATION_START?.[0]?.imageUrl}
						/>
					) : (
						<>-</>
					)}
				</div>
			)
		},
		'Order Amount': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return `₹${item?.finalValue >= 0 ? addCommas(item?.finalValue) : '-'
				}`;
		},
		'Receiving Process': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			if (item?.toProcessName) return item.toProcessName;
			if (item?.toProcessId) {
				return (
					processNameMap[`${item?.storeId}_${item?.toProcessId}`] ??
					'-'
				);
			}
			return '-';
		},
		Download: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			if (isBuyer) {
				return renderDownloadField(item);
			}
			const vendorIdPresent = !!item?.vendorId;
			const clientPOId = item?.clientPoId ?? '-';
			const deliveryDate = item?.scheduledAt;
			const orderDate = moment(item?.createdAt).format('YYYY-MM-DD');
			const orderStatus = item?.orderStatus;
			// PO PDF must not be downloadable while the order is unapproved,
			// rejected or cancelled.
			const isPoPdfDownloadable = isPoDocDownloadable(orderStatus);
			const raisedBy = item?.storeName;
			const fullFilledBy = item?.vendorName ?? '-';
			const CommonValues = [
				item?.id,
				clientPOId,
				deliveryDate,
				orderDate,
				orderStatus,
				raisedBy,
				fullFilledBy,
			];
			const extraHeaders = ['Product Name', 'unit', 'Ordered Quantity'];
			return (
				<div className={styles?.downloadDiv}>
					{item?.poURL && isPoPdfDownloadable && (
						<Chip
							size='small'
							label='Order'
							onClick={() => {
								if (item?.poURL) {
									window.open(item?.poURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
					{item?.jsonData?.uploadedDoc?.file && (
						<Chip
							size='small'
							label='Refrence Doc'
							onClick={() => {
								window.open(item?.jsonData?.uploadedDoc?.file);
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
					{isInternalOrders && item?.invoiceURL && (
						<Chip
							size='small'
							label='Invoice'
							onClick={() => {
								if (item?.invoiceURL) {
									window.open(item?.invoiceURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
					{item?.grnURL && (
						<Chip
							size='small'
							label='GRN'
							onClick={() => {
								if (item?.grnURL) {
									window.open(item?.grnURL);
								}
							}}
							icon={<PictureAsPdfIcon />}
						/>
					)}
				</div>
			);
		},
		Vendor: (vendorName) => {
			return (
				<div
					style={{
						width: '100px',
						textAlign: 'left',
						overflowWrap: 'break-word',
					}}
				>
					{vendorName ?? '-'}
				</div>
			);
		},
		'Order Date': (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			return (
				<div
					style={{
						width: '100px',
						textAlign: 'left',
					}}
				>
					{moment(item?.createdAt)?.format('YYYY-MM-DD') ?? '-'}
				</div>
			);
		},
		Actions: (itemId) => {
			const item = data?.find((poItem) => {
				return poItem?.id === itemId;
			});
			const fullFilled = item?.items.reduce((acc, curr) => acc + curr?.fulfilled, 0);
			const vendorDetails = vendors?.find((ele) => {
				return ele?.id === item?.vendorId;
			});
			const vendorLocation = vendorDetails?.vendor_locations?.find((loc) => {
				return Number(loc?.id) === Number(item?.vendorLocationId);
			});
			const vendorLocationGstin = vendorLocation?.gstin ?? vendorDetails?.gstin ?? '';
			const buyersObj = {
				'Deliver From Store': item?.fromStore,
				Buyer: item?.vendorName,
			};
			const vendorsObj = {
				'Deliver To Store': item?.storeName,
				'Vendor GSTIN': vendorLocationGstin,
				Vendor: item?.vendorName,
				'Vendor Address': `${vendorDetails?.shippingAddressCity ?? ''}${vendorDetails?.shippingAddressState ?? ''
					}, ${vendorDetails?.shippingAddressPinCode ?? ''}`,
			};
			const isInternalObj = {
				'Deliver From Store': item?.vendorName,
				'Deliver To Store GSTIN': item?.storeGstin ?? '',
				'From Store Address': `${vendorDetails?.shippingAddressCity ?? ''
					}${vendorDetails?.shippingAddressState ?? ''}, ${vendorDetails?.shippingAddressPinCode ?? ''
					}`,
			};
			const approvalStatus = item?.approvalStatus;
			const isClosed = item?.orderStatus === 'CLOSED';
			const isVendorPO = item?.subType === 'Vendor';
			const isFullyBilled = isClosed && isVendorPO && item?.jsonData?.billingSummary?.fullyBilled === true;
			const isVendorClosed = isClosed && isVendorPO && !isFullyBilled && (Number(appConfig?.customerId) === 72 || Number(appConfig?.customerId) === 5);

			if (type !== 'BUYER' && type !== 'internalPoList' && console3Action) {
				return (
					<div className={styles.btns}>
						<SButton
							onClick={() => window.open(window.location.origin + '/coo/sourcing/vendors/orders?console2ClientPoId=' + item?.clientPoId)}
							className='flex items-center gap-2 w-full border border-slate-800 text-slate-800 bg-transparent hover:text-white'
						>
							Console 3 <ArrowRight size={16} />
						</SButton>
					</div>
				);
			}

			return (
				<div className={styles['action-btns']}>
					{/* Approval Workflow Block */}
					{item?.orderStatus === 'APPROVAL_PENDING' && item?.orderStatus !== 'APPROVAL_REJECTED' && (() => {
						if (item?.prId) {
							const isFinished = approvalStatus?.isFullyApproved || approvalStatus?.isPermanentlyRejected;
							if (isFinished) return null;

							const pendingLevel = approvalStatus?.currentPendingUserLevel;
							const pendingRoles = approvalStatus?.currentPendingRoles || [];
							const userRoles = Object.values(userRolesDict ?? {});
							const isLevelMatch = pendingLevel ? String(level) === String(pendingLevel) : true;
							const isRoleMatch = pendingRoles?.length > 0 ? pendingRoles.some(role => userRoles.includes(role)) : true;

							if (isLevelMatch && isRoleMatch) {
								return (
									<Tooltip title='Approve Order'>
										<div
											className={classes(styles['icon-btn'], styles.approve)}
											onClick={() => handleReviewModal(item, buyersObj, vendorsObj, isInternalObj)}
										>
											<CheckCircle2 size={18} />
										</div>
									</Tooltip>
								);
							}

							return (
								<Tooltip title='Pending Approval'>
									<div className={classes(styles['icon-btn'], styles.pending)}>
										<Clock size={18} />
									</div>
								</Tooltip>
							);
						}

						// If prId is NOT present, show Review Order for authorized users
						if (levels.includes(level) && (isInternal || procurmentRole)) {
							return (
								<Tooltip title='Review Order'>
									<div
										className={classes(styles['icon-btn'], styles.edit)}
										onClick={() => handleReviewModal(item, buyersObj, vendorsObj, isInternalObj)}
									>
										<CheckCircle2 size={18} />
									</div>
								</Tooltip>
							);
						}
						return null;
					})()}

					{/* Edit Icon — hidden for L3 on Vendor Orders (approve-only) */}
					{!isL3Blocked &&
						(item?.orderStatus === 'APPROVAL_PENDING' || item?.orderStatus === 'APPROVAL_REJECTED' || isVendorClosed) &&
						(!item?.prId || (item?.prId && approvalStatus?.editAllowed)) && (
							<Tooltip title='Edit Order'>
								<div
									className={classes(styles['icon-btn'], styles.edit)}
									onClick={() => {
										history.push(
											`${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?typeId=${isBuyer ? 8 : 1}&${isBuyer ? 'fromStore' : 'toStore'}=${isBuyer ? item?.fromStore : navSelectedStore?.value?.id}&poId=${itemId}${item?.prId ? '&isPr=true' : ''}`,
											{ prevPath: location?.pathname + location?.search }
										);
									}}
								>
									<EditIcon size={18} />
								</div>
							</Tooltip>
						)}
					{/* Upload POD DOC / View Document Icon */}
					{item?.orderStatus === 'TRANSIT' && isBuyer && (
						<>
							{item?.jsonData?.buyerUploadedDoc ? (
								<Tooltip title='View Uploaded POD Document'>
									<div
										className={classes(styles['icon-btn'], styles.view)}
										onClick={() => handleViewDocument(item)}
									>
										<Eye size={18} />
									</div>
								</Tooltip>
							) : (
								<Tooltip title='Upload POD DOC'>
									<div
										className={classes(styles['icon-btn'], styles.edit)}
										onClick={() => handleOpenDocumentModal(item, true)}
									>
										<Upload size={18} />
									</div>
								</Tooltip>
							)}
						</>
					)}

					{/* Cancel PO Icon */}
					{(item?.orderStatus === 'PENDING' || item?.orderStatus === 'APPROVAL_PENDING') && (
						<Tooltip title='Cancel PO'>
							<div
								className={classes(styles['icon-btn'], styles.cancel)}
								onClick={() => {
									toggleAlert(true, {
										heading: 'Cancel PO?',
										handleConfirm: () => {
											handleCancelPo(itemId, item?.clientPoId);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Cancel ${item?.clientPoId || ''}?`,
									});
								}}
							>
								<CircleX size={18} />
							</div>
						</Tooltip>
					)}

					{/* Close PO Icon */}
					{fullFilled > 0 && ['PENDING'].includes(item?.orderStatus) && (
						<Tooltip title='Close PO'>
							<div
								className={classes(styles['icon-btn'], styles.close)}
								onClick={() => {
									toggleAlert(true, {
										heading: 'Close PO?',
										handleConfirm: () => {
											handleCancelPo(itemId, item?.clientPoId, true);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Close ${item?.clientPoId || ''}?`,
									});
								}}
							>
								<Ban size={18} />
							</div>
						</Tooltip>
					)}

					{/* Reschedule & Reopen - abandoned vendor PO: pick a new date (not in the past),
					    the PO goes back to PENDING (RESCHEDULE in handleDatePickerModalSetDate) */}
					{isVendorOrders && !isL3Blocked && item?.orderStatus === 'ABANDONED' && (
						<Tooltip title='Reschedule & Reopen'>
							<div
								className={classes(styles['icon-btn'], styles.edit)}
								onClick={() => handleDatePickerModalOpen(item)}
							>
								<RotateCcw size={18} />
							</div>
						</Tooltip>
					)}

					{/* Hidden once SAP has a PO number for it - a repush would create a duplicate there */}
					{(appConfig?.customerId === 72 || appConfig?.customerId === 5) && item?.jsonData?.sync_sap_order === false &&
						!item?.jsonData?.sap?.vendorPoNumber && !item?.externalOrderRef && (
						<Tooltip title='Re Push Order'>
							<div
								className={classes(styles['icon-btn'], styles.edit)}
								onClick={() => {
									toggleAlert(true, {
										heading: 'Re Push Order?',
										handleConfirm: () => {
											handleRepushOrder(itemId, item?.clientPoId);
											toggleAlert(false);
										},
										colorReverse: false,
										cancelText: 'No',
										confirmText: 'Yes',
										message: `Are you sure you want to Re Push ${item?.clientPoId || 'this order'} to SAP?`,
									});
								}}
							>
								<RefreshCcw size={18} />
							</div>
						</Tooltip>
					)}
				</div>
			);
		},
	};

	const handleEditSubmit = async (editedValues) => {
		try {
			const response = await assetServices.editAssetTemp({
				data: editedValues,
				params: {
					type: 'PO',
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.errorMessage ?? response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error ?? error?.message,
			});
		}
	};

	const exportItemsWiseData = () => {
		const headers = [
			'GRN ID',
			'GRN Start Time',
			'GRN End Time',
			'Product Name',
			'Variant',
			'Unit',
			'Product Category',
			'PO Ordered Quantity',
			'PO Fulfilled Quantity',
			'GRN Fulfilled Quantity',
			'Item Price',
			'Item Tax Percentage',
			'Total Item Tax',
			'Total Item Price',
		];
		const totalValues = [];
		data?.forEach((ele) => {
			if (ele?.grn?.length > 0) {
				ele?.grn?.forEach((grnEle) => {
					const startTime = grnEle?.createdAt
						? moment(grnEle?.createdAt)?.format('HH:MM A')
						: '';
					const endTime = grnEle?.closedAt
						? moment(grnEle?.closedAt)?.format('HH:MM A')
						: '';
					if (grnEle?.items?.length) {
						grnEle?.items?.forEach((item) => {
							totalValues?.push([
								ele?.id,
								ele?.clientPoId ?? '-',
								ele?.scheduledAt,
								moment(ele?.createdAt).format('YYYY-MM-DD'),
								ele?.orderStatus,
								ele?.storeName,
								ele?.vendorName,
								grnEle?.id,
								startTime,
								endTime,
								item?.productName?.replaceAll(',', "'"),
								item?.variantName,
								item?.unit,
								item?.categoryName ?? '-',
								item?.qty,
								'-',
								item?.fulfilled,
								item?.productCost,
								item?.taxPercentage,
								item?.productTaxValue,
								item?.totalValue,
							]);
						});
					} else {
						totalValues?.push([
							ele?.id,
							ele?.clientPoId ?? '-',
							ele?.scheduledAt,
							moment(ele?.createdAt).format('YYYY-MM-DD'),
							ele?.orderStatus,
							ele?.storeName,
							ele?.vendorName,
							grnEle?.id,
							startTime,
							endTime,
							'-',
							'-',
							'-',
							'-',
							'-',
							'-',
							'-',
							'-',
							'-',
							'-',
						]);
					}
				});
			} else {
				ele?.items?.forEach((poItem) => {
					totalValues?.push([
						ele?.id,
						ele?.clientPoId ?? '-',
						ele?.scheduledAt,
						moment(ele?.createdAt).format('YYYY-MM-DD'),
						ele?.orderStatus,
						ele?.storeName,
						ele?.vendorName,
						'-',
						'-',
						'-',
						poItem?.productName?.replaceAll(',', "'"),
						poItem?.variantName,
						poItem?.unit,
						poItem?.categoryName ?? '-',
						poItem?.qty,
						poItem?.fulfilled,
						'-',
						poItem?.productCost,
						poItem?.taxPercentage,
						poItem?.productTaxValue,
						poItem?.totalValue,
					]);
				});
			}
		});
		handleExcelDownload(
			headers,
			totalValues,
			`Vendor_PO_${moment(dateRangeFilter?.from)?.format(
				'YYYY-MM-DD'
			)}_${moment(dateRangeFilter?.to)?.format('YYYY-MM-DD')}`
		);
	};

	const fetchVendorsOrders = (filters, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setFilterValue(filters);
		const filterDateRangeFilter = {
			dateType: filters?.timeType?.value,
			from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		const vendorOrderFilters = {
			fromStoreId: filters?.store?.id,
			status: filters?.status,
			storeId: filters?.deliverFrom?.id === -999 ? null : filters?.deliverFrom?.id,
			vendors: isBuyer ? filters?.buyer?.id : filters?.vendors?.id,
			variantIds: [...new Set(filters?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
			orderType: isInternalOrders
				? 'sales/purchase'
				: isBuyer
					? 'buyers'
					: isManualProduction
						? 'manualProduction'
						: 'vendors',
			userOrderType: isInternalOrders
				? 'purchase'
				: isBuyer
					? 'sales'
					: null,
			dateRangeFilter: filterDateRangeFilter,
			grnStatus: filters?.type === null ? 'ALL' : filters?.type,
			// Deliver To process: the backend matches it against the order's fromProcessId.
			...(isInternalOrders && filters?.toProcess?.id?.length > 0
				? { toProcess: filters.toProcess.id }
				: null),
			// ...(isRefresh ? null : type === 'BUYER' ? 
			// 	search?.value === 'soId' ? {
			// 		poId: search?.searchValue ? Number(search?.searchValue) : null,
			// 	} : {
			// 		clientPoId: search?.searchValue,
			// 	} : search?.value === 'poId' ? {poId: search?.searchValue ? Number(search?.searchValue) : null} : {clientPoId: search?.searchValue}),
			// ...(type === 'internalPoList' ? {
			// } : {}),
		};
		exportFilters.current = vendorOrderFilters;
		// setExportFilters(vendorOrderFilters);
		const req = {
			data: {
				filters: vendorOrderFilters,
			},
		};
		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'VENDOR_ORDERS_LIST',
			req,
		});
	};

	const handleFetchVendorPoStatus = async () => {
		const notificationId = notificationServices.generateNotification({
			type: 'loading',
			message: 'Fetching latest status...',
		});
		try {
			const response =
				await inventoryAnalyticsServices.fetchNagaVendorPoReleaseStatus();
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message ?? 'Status fetched successfully',
					config: { id: notificationId },
				});
				fetchVendorsOrders(filterValue, true);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message:
						response?.errorMessage ??
						response?.message ??
						'Failed to fetch latest status',
					config: { id: notificationId },
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
				config: { id: notificationId },
			});
		}
	};

	const moreOptionsList = {
		'Generate Performa Invoice': (po, cb) => {
			if (po?.orderStatus === 'APPROVAL_PENDING') {
				notificationServices.generateNotification({
					type: 'error',
					message: 'PO is not approved',
				});
				return null;
			}
			if (
				po?.orderStatus === 'FULFILLED' ||
				po?.orderStatus === 'CLOSED'
			) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'PO is already Fulfilled',
				});
				return null;
			}
			const url = `${urls.EXTENSION}${urls.BILLS}/add?poId=${po?.id}&isAdvance=true`;
			history.push(url);
			cb();
			return null;
		},
	};

	const handleApprovePo = async (item, approveReason, uploadedDoc, prId) => {
		// setIsloading(true);
		try {
			let responseData;
			if (prId) {
				responseData = await purchaseRequestServices.updatePurchaseRequestStatus({
					data: {
						action: 'APPROVE',
						entityType: 'PurchaseOrder',
						entityId: item?.id,
						extra: {
							uploadedDoc: uploadedDoc || '',
							reason: approveReason,
						},
					},
				});
			} else {
				responseData =
					await inventoryAnalyticsServices.changeOrderStatus({
						params: {
							poId: item?.id,
							status: 'APPROVE',
							approveReason,
						},
					});
			}
			if (responseData?.statusCode === 200) {
				toggleModal(false);
				fetchVendorsOrders(filterValue, false);
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		// finally {
		// setIsloading(false);
		// }
	};
	const handleRejectPo = async (item, rejectionReason, uploadedDoc, prId) => {
		// setIsloading(true);
		try {
			let responseData;
			if (prId) {
				responseData = await purchaseRequestServices.updatePurchaseRequestStatus({
					data: {
						action: 'REJECT',
						entityType: 'PurchaseOrder',
						entityId: item?.id,
						extra: {
							uploadedDoc: uploadedDoc || '',
							reason: rejectionReason,
						},
					},
				});
			} else {
				responseData =
					await inventoryAnalyticsServices.changeOrderStatus({
						params: {
							poId: item?.id,
							status: 'REJECT',
							rejectionReason,
						},
					});
			}
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				toggleModal(false, {});
				toggleAlert(false, {});

				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};
	// const handleSearchBy = (index) => {
	// 	setSearchField(index);
	// };
	// const handleOrderSearch = (filters) => {
	// 	const searchKey =
	// 		SEARCH_BY?.options?.[searchField !== -1 ? searchField : 0]?.key;
	// 	const vendorOrderFilters = {
	// 		fromStoreId: filters?.store,
	// 		status: filters?.status,
	// 		storeId:
	// 			navSelectedStore?.value?.id === -999
	// 				? null
	// 				: navSelectedStore?.value?.id,
	// 		vendors: isBuyer ? filters?.buyer : filters?.vendors,
	// 		orderType: isInternalOrders
	// 			? 'sales/purchase'
	// 			: isBuyer
	// 				? 'buyers'
	// 				: 'vendors',
	// 		userOrderType: isInternalOrders ? 'purchase' : isBuyer ? 'sales' : null,
	// 		serachKey: {searchKey, value: query} 
	// 	};
	// 	exportFilters.current = vendorOrderFilters;
	// 	const req = {
	// 		data: {
	// 			filters: vendorOrderFilters,
	// 		},
	// 	};
	// 	fetchOrdersList({
	// 		entity: 'INVENTORY_ANALYTICS',
	// 		method: 'VENDOR_ORDERS_LIST',
	// 		req,
	// 	});
	// };
	// const {
	// 	query,
	// 	handleSearch,
	// 	clearSearch,
	// 	searchBy: searchField,

	// 	handleSearchBy: setSearchField,
	// } = useSearch(
	// 	searchQuery,
	// 	SEARCH_BY?.options?.findIndex((option) => {
	// 		return option.key === searchBy;
	// 	}) ?? 0
	// );
	// const footerComponent = () => {
	// 	return (
	// 		<div className={styles.footer} >
	// 			{!isInternalOrders && !isBuyer && (
	// 				<div className={styles.filter}>
	// 					<Label>GRN Status:</Label>
	// 					<Select
	// 					onValueChange={(value) => {
	// 						setGrnStatus(value);
	// 					}}
	// 					value={grnStatus}
	// 				>
	// 					<SelectTrigger className='w-[200px]'>
	// 						<SelectValue placeholder='Theme' />
	// 					</SelectTrigger>
	// 					<SelectContent>
	// 						{[
	// 							'ALL',
	// 							'GRN_UNFULFILLED',
	// 							'GRN_FULFILLED_WITHOUT_BILL',
	// 							'GRN_FULFILLED_WITH_BILL',
	// 						]?.map((ele) => {
	// 							return (
	// 								<SelectItem value={ele}>
	// 									{ele?.split('_')?.join(' ')}
	// 								</SelectItem>
	// 							);
	// 						})}
	// 					</SelectContent>
	// 				</Select>
	// 			</div>
	// 			)}
	// 			{/* {((!isInternalOrders || type === 'internalPoList') || isBuyer) && (
	// 			<div className={`${(!isInternalOrders || type === 'internalPoList') || isBuyer ? 'ml-auto' : ''} `}>
	// 				<SearchBar 
	// 					value={query} 
	// 					handleInput={handleSearch}
	// 					handleChange={handleSearchBy}
	// 					// onChange={onChange}
	// 					searchBy={
	// 						SEARCH_BY != null
	// 							? {
	// 								...(SEARCH_BY ?? {}),
	// 								current:
	// 										searchField === -1
	// 											? 0
	// 											: searchField,
	// 							}
	// 							: null
	// 					}
	// 					className={styles.search}
	// 					showBtn
	// 					handleOrderSearch={handleOrderSearch}
	// 				/>
	// 			</div>
	// 			)} */}
	// 		</div>
	// 	);
	// };

	const handleExport = async (filters) => {
		try {
			setLoading(true);
			const response =
				await orderAnalyticsServices.exportGRNWiseOrderHistory({
					data: {
						filters: {
							...filters
						},
					},
				});
			if (response.status === 200) {
				const exportType = [
					...internalOrdersExportTypes,
					...vendorOrdersExportTypes,
				]?.find((ele) => {
					return ele?.value === filters?.exportType;
				});
				const exportTypeValue = exportType?.label
					?.split(' ')
					?.join('_')
					?.toUpperCase();
				const buyerExportTypeValue = isBuyer ? exportTypeValue === 'INVOICE-WISE_PURCHASE_REGISTER' ? 'INVOICE-WISE_SALES_REGISTER' : exportTypeValue === 'ITEM-WISE_PURCHASE_REGISTER' ? 'ITEM-WISE_SALES_REGISTER' : exportTypeValue : exportTypeValue;
				let exportFileName = `VENDOR_${exportTypeValue}_ORDERS_${filters?.dateRangeFilter?.from}_${filters?.dateRangeFilter?.to}.csv`;
				if (isInternalOrders) {
					exportFileName = `INTERNAL_PURCHASE_ORDERS_${filters?.dateRangeFilter?.from}_${filters?.dateRangeFilter?.to}.csv`;
				} else if (isBuyer) {
					exportFileName = `BUYER_${buyerExportTypeValue}_ORDERS_${filters?.dateRangeFilter?.from}_${filters?.dateRangeFilter?.to}.csv`;
				}
				handleResponseStreamDownload(response, exportFileName);
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Some error occurred',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: error,
			});
		} finally {
			setLoading(false);
		}
	};

	const DATE_TYPES = useMemo(() => {
		return dateTypeArr?.filter((ele) => {
			if (isInternalOrders) {
				return ele?.value !== 'grn';
			}
			if (isBuyer) {
				return !(ele?.value === 'received' || ele?.value === 'grn' || ele?.value === 'dispatchDate');
			}
			return !(ele?.value === 'invoiced' || ele?.value === 'received' || ele?.value === 'dispatchDate');
		});
	}, [isInternalOrders, isBuyer]);

	// const openExportDrawer = () => {
	// 	const exportTypeDefaultValue = isInternalOrders
	// 		? internalOrdersExportTypes?.[1]?.value
	// 		: vendorOrdersExportTypes?.[1]?.value;
	// 	let heading = 'Export Internal Purchase Orders';
	// 	if (!isInternalOrders && type !== 'BUYER') {
	// 		heading = 'Export Vendor Orders';
	// 	} else if (type === 'BUYER') {
	// 		heading = 'Export Buyer Orders';
	// 	}
	// 	toggleExportFiltersDrawer(true, {
	// 		heading,
	// 		// note: 'Filters are disabled for now, they will be LIVE Soon!',
	// 		onConfirm: (args) => {
	// 			const { filtersState } = args ?? {};
	// 			handleExport({
	// 				...exportFilters.current,
	// 				dateRangeFilter: {
	// 					dateType: filtersState?.dateRangeInput,
	// 					from: moment(filtersState?.dateRange?.from).format(
	// 						'YYYY-MM-DD'
	// 					),
	// 					to: moment(filtersState?.dateRange?.to).format(
	// 						'YYYY-MM-DD'
	// 					),
	// 				},
	// 				categories: filtersState?.categories,
	// 				subCategories: filtersState?.subCategories,
	// 				exportType: filtersState?.exportType,
	// 			});
	// 		},
	// 		filterData: [
	// 			{
	// 				type: 'tabSelect',
	// 				dependentOn: -1,
	// 				compData: isInternalOrders
	// 					? internalOrdersExportTypes
	// 					: vendorOrdersExportTypes,
	// 				selectBy: 'value',
	// 				label: 'Export Type',
	// 				selectedValueKey: 'exportType',
	// 				dateFormat: null,
	// 				defaultState: exportTypeDefaultValue,
	// 				disabled: false,
	// 			},
	// 			{
	// 				type: 'singleSelect',
	// 				dependentOn: -1,
	// 				compData: categoriesList?.map((ele) => {
	// 					return {
	// 						id: ele?.id,
	// 						value: ele?.id,
	// 						title: ele?.productCategoryName,
	// 						label: ele?.productCategoryName,
	// 					};
	// 				}),
	// 				selectBy: 'id',
	// 				label: 'Category',
	// 				selectedValueKey: 'categories',
	// 				dateFormat: null,
	// 				disabled: true,
	// 				defaultState: null,
	// 			},
	// 			{
	// 				type: 'multiSelect',
	// 				dependentOn: 1,
	// 				compData: [],
	// 				selectBy: 'id',
	// 				label: 'Sub-Categories',
	// 				selectedValueKey: 'subCategories',
	// 				dateFormat: null,
	// 				defaultState: [],
	// 				disabled: true,
	// 				dataPropKey: 'subCategories',
	// 				onDependencyUpdate: (dependencyState) => {
	// 					if (dependencyState) {
	// 						fetchSubCategories({
	// 							entity: 'PRODUCT_SUB_CATEGORY',
	// 							req: {
	// 								params: {
	// 									categoryId: dependencyState,
	// 								},
	// 							},
	// 							method: 'LIST',
	// 						});
	// 					}
	// 				},
	// 			},
	// 			{
	// 				type: 'dateRange',
	// 				dependentOn: -1,
	// 				compData: [],
	// 				selectBy: '',
	// 				label: 'Date Range',
	// 				selectedValueKey: 'dateRange',
	// 				dateFormat: null,
	// 				withInput: true,
	// 				disabled: false,
	// 				dataPropKey: '',
	// 				defaultState: {
	// 					from: new Date(
	// 						exportFilters?.current?.dateRangeFilter?.from
	// 					),
	// 					to: new Date(
	// 						exportFilters?.current?.dateRangeFilter?.to
	// 					),
	// 				},
	// 			},
	// 			{
	// 				type: 'dateRangeInput',
	// 				dependentOn: -1,
	// 				compData: DATE_TYPES,
	// 				selectBy: '',
	// 				disabled: false,
	// 				label: 'Date Type',
	// 				selectedValueKey: 'dateRangeInput',
	// 				dateFormat: null,
	// 				defaultState:
	// 					exportFilters?.current?.dateRangeFilter?.dateType,
	// 			},
	// 		],
	// 	});
	// };

	const handleOnUpdate = (filters) => {
		const filterDateRangeFilter = {
			dateType: filters?.timeType,
			from: moment(filters?.dateRange?.from).format('YYYY-MM-DD'),
			to: moment(filters?.dateRange?.to).format('YYYY-MM-DD'),
		};
		// console.log('filters', filters);
		const vendorOrderFilters = {
			fromStoreId: filters?.store?.id,
			status: filters?.status,
			storeId:
				navSelectedStore?.value?.id === -999
					? null
					: navSelectedStore?.value?.id,

			vendors: isBuyer ? filters?.buyer : filters?.vendors?.id,
			orderType: isInternalOrders
				? 'sales/purchase'
				: isBuyer
					? 'buyers'
					: isManualProduction
						? 'manualProduction'
						: 'vendors',
			userOrderType: isInternalOrders
				? 'purchase'
				: isBuyer
					? 'sales'
					: null,
			dateRangeFilter: filterDateRangeFilter,
			grnStatus,
			...(isInternalOrders && filters?.toProcess?.id?.length > 0
				? { toProcess: filters.toProcess.id }
				: null),
		};
		exportFilters.current = vendorOrderFilters;
		// setExportFilters(vendorOrderFilters);
	};

	const filtersVendor = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		deliverFrom: {
			text: 'Deliver To',
			show: true,
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		type: {
			text: 'Grn Status',
			show: true,
			list: [

				{
					label: 'ALL',
					type: 'ALL',
				},
				{
					label: 'GRN UNFULFILLED',
					type: 'GRN_UNFULFILLED',
				},
				{
					label: 'GRN FULFILLED WITHOUT BILL',
					type: 'GRN_FULFILLED_WITHOUT_BILL',
				},
				{
					label: 'GRN FULFILLED WITH BILL',
					type: 'GRN_FULFILLED_WITH_BILL',
				}
			]

		},
		vendor: {
			text: 'Placed To (Vendor)',
			show: true,
		},
		timeType: {
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
	}
	const filtersBuyer = {
		header: {
			store: false,
			date: false,
			statusAndTypes: false,
			product: false,
		},
		store: {
			text: 'Deliver From',
			show: true,
			permittedStore: true,
		},
		buyer: {
			text: 'Buyer',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
	}

	const internalPoInfo = {
		header: {
			store: false,
			statusAndTypes: false,
			date: false,
			process: false,
			product: false,
		},
		store: {
			text: 'Deliver From',
			show: true,
		},
		deliverFrom: {
			text: 'Deliver To',
			show: true,
		},
		// Options are the processes of the Deliver To store (the deliverFrom filter here).
		toProcess: {
			text: 'Deliver To Process',
			show: true,
			multiSelect: true,
			processStore: 'deliverFrom',
		},
		dateRangeWithType: {
			text: 'Date Range',
			show: true,
		},
		status: {
			text: 'Order Status',
			show: true,
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
		productWithVariants: {
			text: 'Product',
			show: true,
		},
	}

	const dropDownItems = [
		{
			label: 'Client PO ID',
			value: 'clientPoId',
			placeholder: 'Search by Client PO ID',
			getData: true,
		},
		{
			label: 'PO ID',
			value: 'poId',
			placeholder: 'Search by Po ID',
			getData: true,
		},
	];

	const buyerDropDownItems = [
		{
			label: 'Client SO ID',
			value: 'clientSoId',
			placeholder: 'Search by Client SO ID',
			getData: true,
		},
		{
			label: 'SO ID',
			value: 'soId',
			placeholder: 'Search by SO ID',
			getData: true,
		},
		{
			label: 'Order Ref No',
			value: 'orderRefNo',
			placeholder: 'Search by Order Ref No',
			getData: true,
		},
		{
			label: 'Invoice No',
			value: 'invoiceNo',
			placeholder: 'Search by Invoice No',
			getData: true,
		}
	];

	useEffect(() => {
		if (search?.keyPress && search?.searchValue?.trim() === '') {
			fetchVendorsOrders(filterValue);
		}
	}, [search?.searchValue]);

	const idSearch = () => {
		const filters = {
			orderType: isInternalOrders
				? 'sales/purchase'
				: isBuyer
					? 'buyers'
					: isManualProduction
						? 'manualProduction'
						: 'vendors',
			userOrderType: isInternalOrders
				? 'purchase'
				: isBuyer
					? 'sales'
					: null,
			...(search?.value === 'clientPoId' ? { clientPoId: search?.searchValue } : search?.value === 'soId' ? { poId: Number(search?.searchValue) } : {}),
			...(search?.value === 'poId' ? { poId: Number(search?.searchValue) } : search?.value === 'clientSoId' ? { clientPoId: search?.searchValue } : {}),
			...(search?.value === 'orderRefNo' && { orderRefNo: search?.searchValue }),
			...(search?.value === 'invoiceNo' && { invoiceNo: search?.searchValue }),
		};
		const req = {
			data: {
				filters: filters,
			},
		};
		fetchOrdersList({
			entity: 'INVENTORY_ANALYTICS',
			method: 'VENDOR_ORDERS_LIST',
			req,
		});
	}
	const handleCall = (e) => {
		if (e.key === 'Enter') {
			idSearch();
		}
	}
	const exportInfo = {
		showDropDown: true,
		showExportBtn: true,
		exportTypes: isInternalOrders
			? internalOrdersExportTypes
			: vendorOrdersExportTypes,
	};

	return (
		<div className={styles.root}>
			<OrderImagesModal />
			<BackdropLoader showProgress isLoading={loading} />
			<AlertModal />
			<DocumentModal />
			<FileUploaderModal handleConfirm={handleDocUpload} />
			<DatePickerModal
				show={datePickerModalState?.show}
				heading={datePickerModalState?.heading}
				restrictDateType='before'
				currentPo={datePickerModalState?.currentPo}
				onClose={() => {
					setDatePickerModalState({ show: false, heading: '' });
				}}
				onSubmit={handleDatePickerModalSetDate}
			/>
			<POItemsModal
				handleConfirm={handleApprovePo}
				handleReject={handleRejectPo}
			/>
			<VendorOrderGrnsModal />
			<AssetTransitModal />
			{isBuyer && <MultiPoModal />}
			<VanImageModal handleEditSubmit={handleEditSubmit} />
			<DebitCreditListDrawer />
			<ExportFiltersDrawer
				subCategories={subCategoriesList?.map((ele) => {
					return {
						id: ele?.id,
						value: ele?.id,
						title: ele?.categoryName,
						label: ele?.categoryName,
					};
				})}
			/>
			<div className={styles.header}>
				<ImagesFinder
					onSubmit={fetchVendorsOrders}
					update={update}
					timeTypeArray={DATE_TYPES}
					statusList={
						type === 'BUYER' || type === 'internalPoList'
							? filterOrderStatus
								?.map((ele) => {
									if (
										isBuyer &&
										(ele === 'APPROVAL_PENDING' ||
											ele === 'APPROVAL_REJECTED')
									) {
										return null;
									}
									if (ele === 'FULFILLED') {
										return {
											id: ele,
											title: 'CLOSED',
										};
									}
									if (ele === 'TRANSIT') {
										return {
											id: ele,
											title: 'IN TRANSIT',
										};
									}
									if (ele === 'DISPATCH') {
										return {
											id: ele,
											title: 'PENDING DISPATCH',
										};
									}
									if (ele === 'UNLOADING') {
										return {
											id: ele,
											title: 'UNLOADING STARTED',
										};
									}
									if (ele === 'VERIFICATION') {
										return {
											id: ele,
											title: 'PENDING VERIFICATION',
										};
									}
									return {
										id: ele,
										title: ele,
									};
								})
								.filter((ele) => ele !== null)
							: vendorOrder(vendorOrderStatus)
					}
					onUpdate={handleOnUpdate}
					preventDateRangeCheckbox
					filtersInfo={
						type === 'BUYER'
							? filtersBuyer
							: type === 'internalPoList'
								? internalPoInfo
								: filtersVendor
					}
					orderText
					exportInfo={exportInfo}
				/>
			</div>
			<div className='flex justify-between items-center w-full p-4'>
				<span className='font-bold text-[16px]'>
					{isInternalOrders
						? 'Internal Purchase Orders'
						: isBuyer
							? 'Buyer Orders'
							: isManualProduction
								? 'Manual Production Orders'
								: 'Vendor Orders'}
				</span>
				<div className='flex items-center gap-2'>
					{/* On Vendor Orders, L3 can only approve — creation hidden */}
					{level !== 1 && !isL3Blocked && (
						<>
							{isBuyer && (
								<Button
									onClick={() => {
										dispatch(
											modalActions.toggleMultiplePoModal(
												true,
												{
													mode: 'buyerOrder',
												}
											)
										);
									}}
									className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
								>
									+ Create Multiple Buyer Order
								</Button>
							)}
							{/* Check for draft existence */}
							{(function () {
								let typeId = 1;
								if (isBuyer) {
									typeId = 8;
								}
								if (isInternalOrders) {
									if (
										navSelectedStore?.value?.type === 'BASE'
									) {
										typeId = 3;
									} else {
										typeId = 2;
									}
								}
								const storageKey = getStorageKey(typeId);
								const draft = loadState(storageKey);
								// Show "Edit Draft" only while the draft is fresh
								// (saved within the last 30 minutes).
								const DRAFT_TTL_MS = 30 * 60 * 1000;
								const isDraftFresh =
									draft?.draftSavedAt &&
									Date.now() - draft.draftSavedAt < DRAFT_TTL_MS;

								if (draft && isDraftFresh) {
									return (
										<Button
											onClick={() => {
												const storeSelectionText =
													isBuyer ? '' : 'toStore';
												const baseUrl =
													navSelectedStore?.value
														?.id !== -999
														? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}&${storeSelectionText}=${navSelectedStore?.value?.id}`
														: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER
														}${isInternalOrders
															? '?exclude=1'
															: `?typeId=${typeId}`
														}&userOrderType=purchase`;

												history.push(
													`${baseUrl}${baseUrl.includes('?')
														? '&'
														: '?'
													}editDraft=true`,
													{
														prevPath:
															location?.pathname +
															location?.search,
													}
												);
											}}
											className='bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-md flex items-center justify-center gap-2 text-white shadow-lg transform transition-all duration-1000 hover:scale-105'
										>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												className='h-5 w-5'
												viewBox='0 0 20 20'
												fill='currentColor'
											>
												<path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
											</svg>
											Edit Draft
										</Button>
									);
								}
								return null;
							})()}

							<Button
								onClick={() => {
									let typeId = 1;
									if (isBuyer) {
										typeId = 8;
									}
									if (isInternalOrders) {
										if (
											navSelectedStore?.value?.type ===
											'BASE'
										) {
											typeId = 3;
										} else {
											typeId = 2;
										}
									}
									const storeSelectionText = isBuyer
										? ''
										: 'toStore';
									const baseUrl =
										navSelectedStore?.value?.id !== -999
											? `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER}?userOrderType=purchase&typeId=${typeId}&${storeSelectionText}=${navSelectedStore?.value?.id}`
											: `${urls.EXTENSION}${urls.CREATE_PURCHASE_ORDER
											}${isInternalOrders
												? '?exclude=1'
												: `?typeId=${typeId}`
											}&userOrderType=purchase`;
									const storageKey = getStorageKey(typeId);
									const draft = loadState(storageKey);
									const DRAFT_TTL_MS = 30 * 60 * 1000;
									const isDraftFresh =
										draft?.draftSavedAt &&
										Date.now() - draft.draftSavedAt < DRAFT_TTL_MS;
									// A draft older than 30 mins is discarded, not offered for editing.
									if (draft && !isDraftFresh) {
										localStorage.removeItem(storageKey);
									}
									if (draft && isDraftFresh) {
										toggleAlert(true, {
											heading: 'Draft Exists',
											message: 'There is already a draft for this order type. Would you like to edit the draft or create a new order?',
											confirmText: 'Edit Draft',
											cancelText: 'Create New',
											colorReverse: false,
											handleConfirm: () => {
												let redirectUrl = baseUrl;
												if (redirectUrl.includes('?')) {
													redirectUrl += '&editDraft=true';
												} else {
													redirectUrl += '?editDraft=true';
												}
												history.push(redirectUrl, {
													prevPath: location?.pathname + location?.search,
												});
												toggleAlert(false);
											},
											handleCancel: () => {
												localStorage.removeItem(getStorageKey(typeId))
												history.push(baseUrl, {
													prevPath: location?.pathname + location?.search,
												});
												toggleAlert(false);
											},
										});
									} else {
										history.push(baseUrl, {
											prevPath: location?.pathname + location?.search,
										});
									}
								}}
								className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
							>
								+ Create Order
							</Button>
						</>
					)}
				</div>
			</div>
			<div className='flex gap-3 w-full justify-start items-center py-1'>
				<div className={isNagaOrDevBuyer ? 'flex-1 min-w-0' : 'w-[82%]'}>
					<GlobalSearch
						dropDownOptions={
							type === 'BUYER'
								? buyerDropDownItems
								: dropDownItems
						}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						pageType={type}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip
					title={
						isInternalOrders
							? 'Refresh Internal Purchase Orders'
							: isBuyer
								? 'Refresh Buyer Orders'
								: 'Refresh Vendor Orders'
					}
				>
					<RefreshCcw
						className='size-5 cursor-pointer'
						onClick={() => {
							fetchVendorsOrders(filterValue, true);
						}}
					/>
				</Tooltip>
				{isNagaOrDevBuyer && (
					<Button
						onClick={handleFetchVendorPoStatus}
						sx={{ textTransform: 'none', minWidth: 0 }}
						className='flex items-center gap-1.5 px-3 py-2  text-white bg-blue-600 border border-gray-300 rounded-md hover:bg-blue-700 shrink-0'
					>
						<span className='text-nowrap'>Fetch Latest Status</span>
						<RefreshCcw className='size-4' />
					</Button>
				)}
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							handleDataExport: (filtersState) =>
								handleExport({
									...exportFilters.current,
									dateRangeFilter: {
										dateType: filtersState?.timeType?.value,
										from: moment(
											filtersState?.dateRange?.from
										).format('YYYY-MM-DD'),
										to: moment(
											filtersState?.dateRange?.to
										).format('YYYY-MM-DD'),
									},
									variantIds: [...new Set(filtersState?.productWithVariant?.productData?.flatMap(item => item?.variantIds))],
									// categories: null,
									// subCategories: [],
									exportType: filtersState?.exportType,
								}),
						});
					}}
					className='flex items-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
			</div>
			<div className='flex items-center w-full'>
				{!isBuyer && !isInternalOrders && (
					<div className='px-2 shrink-0'>
						<div className='grid grid-cols-4 gap-x-2 gap-y-0.5'>
							{[
								{ color: 'white', border: '1px solid #d1d5db', label: 'Pending' },
								{ color: 'rgba(255, 187, 0, 0.25)', label: 'Approval Pending' },
								{ color: 'rgba(255, 0, 0, 0.25)', label: 'Approval Rejected' },
								{ color: 'rgba(0, 245, 232, 0.59)', label: 'Closed (Pending Bill)' },
								{ color: 'rgba(0, 100, 0, 0.65)', label: 'Closed & Billed' },
								{ color: 'rgba(255, 0, 0, 0.5)', label: 'Cancelled' },
								{ color: 'rgba(200, 0, 0, 0.5)', label: 'Abandoned' },
							].map(({ color, border, label }) => (
								<div key={label} className='flex items-center gap-1'>
									<div style={{ width: 10, height: 10, borderRadius: 2, background: color, border: border ?? '1px solid rgba(0,0,0,0.1)', flexShrink: 0 }} />
									<span className='text-[10px] text-gray-500 whitespace-nowrap'>{label}</span>
								</div>
							))}
						</div>
					</div>
				)}
				<div className='flex-1 min-w-0'>
					{filtersInfoChip(
						type === 'BUYER'
							? filtersBuyer
							: type === 'internalPoList'
								? internalPoInfo
								: filtersVendor,
						filterValue
					)}
				</div>
			</div>
			<div
				className={styles?.table}
				style={{
					width: '100%',
				}}
			>
				<ListTable
					hasDateRange
					allowChangeColumn
					colMap={COLMAP}
					fixedHeaderTop='0'
					columns={TABLE_COLUMNS?.filter((ele) => {
						if (isBuyer) {
							return (
								ele?.title !== 'Vendor Challan ID' &&
								ele?.title !== 'Vendor' &&
								ele?.title !== 'Deliver To' &&
								ele?.title !== 'PO Id' &&
								ele?.title !== 'Client PO Id'
							);
						}
						if (!isInternalOrders) {
							return (
								ele?.title !== 'Deliver From' &&
								ele?.title !== 'SO Id' &&
								ele?.title !== 'Client SO Id' &&
								ele?.title !== 'Order Ref No' &&
								ele?.title !== 'Buyer'
							);
						}
						return (
							ele?.title !== 'Buyer' &&
							ele?.title !== 'Vendor Challan ID' &&
							ele?.title !== 'Vendor' &&
							ele?.title !== 'Last Action BY' &&
							ele?.title !== 'Order Ref No' &&
							ele?.title !== 'SO Id' &&
							ele?.title !== 'Client SO Id'
						);
					})}
					data={data?.map((ele) => {
						const isClosed = ele?.orderStatus === 'CLOSED';
						const isVendorPO = ele?.subType === 'Vendor';
						const isFullyBilled = isClosed && isVendorPO && ele?.jsonData?.billingSummary?.fullyBilled === true;
						const isVendorClosed = isClosed && isVendorPO && !isFullyBilled;
						return {
							...ele,
							rowStyles: classes(
								styles.row,
								isFullyBilled ? styles.CLOSED_BILLED
									: isVendorClosed ? styles.VENDOR_CLOSED
										: styles?.[ele?.orderStatus]
							),
						};
					})}
					actions={[
						...SPECIAL_COLUMNS,
						...getActionColumn(
							BASE_COLUMN,
							ADDITIONAL_COLUMNS,
							level
						),
					]?.filter((ele) => {
						const hideForBuyerOrInternal = (isInternalOrders || isBuyer) && (ele?.title === 'order Completion' || ele?.title === 'Lead Time (Days)');
						if (hideForBuyerOrInternal) return false;
						if (ele?.title === 'Receiving Process' && !isVendorOrders) return false;
						if (!isInternalOrders) {
							return (
								ele?.titles !== 'View' &&
								ele?.title !== 'Expected Receive date' &&
								ele?.title !== 'Generation Type' &&
								ele?.title !== 'Vehicle No' &&
								ele?.title !== 'Vehicle Image at Dispatch' &&
								ele?.title !== 'Vehicle Image at Receiving' &&
								ele?.title !== 'Temp Meter Image' &&
								ele?.title !== 'Vehicle No'
							);
						}
						return ele?.title !== 'MORE';
					})}
					special={SPECIAL_ITEMS}
					handleViewClick={handleViewClick}
					allowExport={false}
					moreOptionsList={moreOptionsList}
					viewMoreOptionsList={
						isInternalOrders
							? internalViewMoreOptions
							: viewMoreOptionsList
					}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state?.navigation;
	const { VENDOR_ORDERS_LIST: data } = state?.analytics?.INVENTORY_ANALYTICS;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	const { LIST: vendors } = state.form.ALL_VENDORS.data;
	const categoriesList = state.form.PRODUCT_CATEGORY.data.LIST;
	const subCategoriesList = state.form.PRODUCT_SUB_CATEGORY.data.LIST;
	const { userList } = state?.auth;
	return {
		data,
		dateRangeFilter,
		navState,
		userPermissions,
		vendors,
		categoriesList,
		subCategoriesList,
		userList,
	};
};

const mapDispatchToProps = {
	setDateRangeFilter: analyticsAction.setDateRangeFilter,
	toggleModal: modalActions.togglePOItemsModal,
	toggleVendorOrderGrnsModal: modalActions.toggleVendorOrderGrnsModal,
	toggleAlert: modalActions.toggleAlert,
	toggleVanImageModal: modalActions.toggleVanImageModal,
	// toggleFileUploaderModal: modalActions.toggleFileUploaderModal,
	toggleTransactionsModal: modalActions.toggleTransactionsModal,
	fetchOrdersList: analyticsAction.gateway,
	fetchVendors: formActions.gateway,
	resetInventoryAnalyticsState: analyticsAction.resetInventoryAnalyticsState,
	toggleExportFiltersDrawer: drawerActions.toggleExportFiltersDrawer,
	fetchSubCategories: formActions.gateway,
	toggleDebitCreditListDrawer: drawerActions.toggleDebitCreditListDrawer,
	toggleAssetTransit: modalActions.toggleAssetTransit,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
	toggleOrderImagesModal: modalActions.toggleOrderImagesModal
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(VendorOrdersListPage);
